import { ApiCatch } from "@/utils/decorators";
import { Api } from "../api.service";

export class AbonentInfoService {
  @ApiCatch
  static async getAbonentInfo(id: string) {
    //
    const response = await Api.get("/abonent/" + id);

    return response.data;
  }
}
